import { CONVERSATIONS_ROUTE } from 'src/app/modules/conversation/constants/route.constants';

export const DEFAULT_CONVERSATIONS_FILTER = {
  latest: CONVERSATIONS_ROUTE.LATEST,
  myConversations: CONVERSATIONS_ROUTE.MY_CONVERSATIONS,
  following: CONVERSATIONS_ROUTE.FOLLOWING,
  mentions: CONVERSATIONS_ROUTE.MENTIONS,
  communityConversations: 'communityConversations',
};
